import {Component, OnDestroy, OnInit} from '@angular/core';
import {navItems} from './sidebar-data';
import {NavService} from '../../../../services/nav.service';
import {AuthService} from '../../../../services/auth.service';
import {PermissionService} from 'src/app/permission.service';
import {debounceTime, Subject} from 'rxjs';
import {RouteMasterService} from 'src/app/route-master.service';
import {Router} from '@angular/router';
import {environment} from 'src/environments/environment';

@Component({
    selector: 'app-vertical-sidebar',
    templateUrl: './vertical-sidebar.component.html',
    styleUrls: [],
})
export class VerticalSidebarComponent implements OnInit, OnDestroy {
    navItems = [];
    navList: any;
    pagePermission: any;
    searchText: string = '';
    private searchSubject = new Subject<string>();

    constructor(
        public navService: NavService,
        private authService: AuthService,
        private permissionService: PermissionService,
        private routeMasterService: RouteMasterService,
        private router: Router
    ) {
    }

    externalAppUrl = 'invoice/list'
    showArthakoshLink = environment.arthakoshFrontendBaseUrl;

    ngOnInit(): void {
        this.navService.landingPage.next(JSON.parse(localStorage.getItem('current_user')).skip_tutorial);
        this.navItems = navItems.filter((item) => {
            return (
                item.roles.indexOf(this.authService.getUserProfile().role) > -1
            );
        });
        this.getNavList();

        this.searchSubject.pipe(debounceTime(1000)).subscribe(searchValue => {
            this.searchText = searchValue;
        });
    }

    getNavList() {
        this.navService.getSideBarlinks().subscribe((response) => {
            this.navList = response;
            console.log('this.navList 1 --------->', this.navList, this.navItems);
        });
    }

    navigateArthakosh() {
        window.location.href = 'https://uatarthkosh.sarjak.com/';
    }

    onSearchInput(event: any) {
        this.searchSubject.next(event.target.value); // Push the value into the Subject
    }

    ngOnDestroy() {
        this.searchSubject.unsubscribe(); // Clean up to avoid memory leaks
    }
}
